import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP = { display: "+91 62803 09868", link: "https://wa.me/916280309868" };
export const http = axios.create({ baseURL: API, withCredentials: true });

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export const today = (offset = 0) => {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d.toLocaleDateString("en-CA");
};

export const hhmm = (mins) => `${Math.floor(mins / 60)}h ${String(mins % 60).padStart(2, "0")}m`;

export const addMinutes = (time, mins) => {
  const [h, m] = time.split(":").map(Number);
  const t = (h * 60 + m + mins) % 1440;
  const dayShift = Math.floor((h * 60 + m + mins) / 1440);
  return `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}${dayShift ? ` +${dayShift}` : ""}`;
};

export const CLASS_MULT = { economy: 1, premium_economy: 1.6, business: 3.2 };

export const cabFare = (cab, tripType, km, roundTrip) => {
  if (tripType === "airport") return cab.airport_fare;
  if (tripType === "local") return cab.local_fare;
  return Math.floor(Math.max(Number(km) || 0, 100) * (roundTrip ? 2 : 1) * cab.rate_per_km + 400);
};

export const downloadPdf = async (b) => {
  const r = await http.get(`/bookings/${b.id}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `NextVisionSolutions-${b.ref}.pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const offerText = (o) =>
  o.discount_type === "percent" ? `${o.value}% OFF` : `₹${Number(o.value).toLocaleString("en-IN")} OFF`;

export const login = (path) => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + (path || window.location.pathname + window.location.search);
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
